import { Icon } from "@chakra-ui/react";

export const CirclePlusIcon = (props: any) => {

return (<Icon {...props}>
<path d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 1a8 8 0 100 16A8 8 0 009 1zm0 3.5a.5.5 0 01.5.5v3.5H13a.5.5 0 110 1H9.5V13a.5.5 0 11-1 0V9.5H5a.5.5 0 010-1h3.5V5a.5.5 0 01.5-.5z" fill="currentColor"></path>
</Icon>);

}